module.exports = __webpack_public_path__ + "img/icon_weather_309.132a64b7.svg";